  <div id="homeContainer" class="container">
    <div class="row row align-items-center">
      <div class="col-xl-6">
        <div id="homeDesc">
          <h3>{{ 'homePage.title' | translate }}</h3>
          <div class="mediumSeparator"></div>
          <p class="m-0 ">{{ 'homePage.desc' | translate }}</p>
          <p class="m-0">{{ 'homePage.desc2' | translate }}</p>
          <p class="m-0">{{ 'homePage.desc3' | translate }}</p>
        </div>
        
      </div>
      <div class="mediumSeparator"></div>
      <div class="col-xl-6 text-center">
        <div id="homeImg" class="d-inline-block">
           <ngu-carousel #myCarouselHome [inputs]="carouselConfigHome" [dataSource]="carouselItemsHome">
            <div *nguCarouselDef="let itemHome;" class="item">
              <div class="tile">
                <div class="mt-3" id="locationImg">
                  <img src="assets/images/home/{{itemHome}}.jpg" alt="" width="409px">
                </div>
                <ul class="myPoint" NguCarouselPoint>
                  <li *ngFor="let q of myCarouselHome.pointNumbers; let f = index" [class.active]="q==myCarouselHome.activePoint" (click)="myCarouselHome.moveTo(j)"></li>
                </ul>
              </div>
            </div>
            <button NguCarouselNext class="fas fa-chevron-right arrow rightRs"></button>
            <button NguCarouselPrev class="fas fa-chevron-left arrow leftRs"></button>
          </ngu-carousel>
          <div id="airbnbButton" class="mt-3">
            <app-airbnb-button></app-airbnb-button>
          </div>
        </div>
      </div>
    </div>
  </div>